<template>
  <form @submit.prevent="handleForm" class="overflow-auto">
    <table v-if="onDesk" class="w-100 mb-3" aria-describedby="table for parent goals desktop">
      <tr>
        <th>
          <p>How well did I meet my goals (today or this week)?</p>
        </th>
        <th v-for="optionAnswer in optionalAnswers" class="px-3" :key="optionAnswer.id">
          {{ optionAnswer.text }}
        </th>
      </tr>
      <tr v-for="skill in skills" :key="skill.id" class="bg-plain2 border-table">
        <td class="py-2 px-3">
          <div class="d-flex align-items-center">
            <b-icon
              :icon="isAFavoriteSkill(skill.id) ? 'star-fill' : 'star'"
              aria-hidden="true"
              class="mr-2"
              :class="isAFavoriteSkill(skill.id) ? 'star-checked' : 'star-uncheck'"
              @click="() => handleFavoriteSkill(skill.id)"
            ></b-icon>
            <p class="font-weight-bold">{{ skill.text }}</p>
          </div>
          <li class="pl-3">{{ skill.questions[0].question }}</li>
        </td>
        <td
          class="text-center"
          v-for="(optionAnswer, index) in optionalAnswers"
          :key="`asnwer-${index}-skill-${skill.id}`"
        >
          <label class="mx-3">
            <input
              type="radio"
              :value="optionAnswer.id"
              :name="`skill-${skill.questions[0].id}-${skill.id}`"
              v-model.lazy="answer[skill.questions[0].id]"
              @change="touched = true"
            />
          </label>
        </td>
        <td>
          <b-icon
            class="mx-3 pointer"
            icon="three-dots-vertical"
            :id="`popover-pg-${skill.id}`"
          ></b-icon>
          <b-popover :target="`popover-pg-${skill.id}`" triggers="focus hover">
            <span class="d-block pointer" @click.stop="$emit('onEditGoal', { skillId: skill.id })"
              >Edit</span
            >
            <span
              class="d-block pointer"
              @click.stop="$router.push({ name: 'PlanDescription', params: { Mid: skill.id } })"
              >Learn</span
            >
            <span
              class="d-block pointer"
              @click.stop="handleDelete(skill.id, skill.questions[0].id)"
              >Delete</span
            >
          </b-popover>
        </td>
      </tr>
    </table>

    <div v-else>
      <p>How well did I meet my goals (today or this week)?</p>
      <section class="w-100 mb-3" aria-describedby="table for parent goals mobile">
        <div v-for="skill in skills" :key="skill.id" class="bg-plain2 border-table">
          <div class="py-2 px-3">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex">
                <b-icon
                  :icon="isAFavoriteSkill(skill.id) ? 'star-fill' : 'star'"
                  aria-hidden="true"
                  class="mr-2"
                  :class="isAFavoriteSkill(skill.id) ? 'star-checked' : 'star-uncheck'"
                  @click="() => handleFavoriteSkill(skill.id)"
                ></b-icon>
                <p class="font-weight-bold">{{ skill.text }}</p>
              </div>
              <div>
                <b-icon
                  class="pointer"
                  icon="three-dots-vertical"
                  :id="`popover-pg-${skill.id}`"
                ></b-icon>
                <b-popover :target="`popover-pg-${skill.id}`" triggers="click focus mouseleave blur">
                  <span
                    class="d-block pointer"
                    @click.stop="$emit('onEditGoal', { skillId: skill.id })"
                    >Edit</span
                  >
                  <span
                    class="d-block pointer"
                    @click.stop="
                      $router.push({ name: 'PlanDescription', params: { Mid: skill.id } })
                    "
                    >Learn</span
                  >
                  <span
                    class="d-block pointer"
                    @click.stop="handleDelete(skill.id, skill.questions[0].id)"
                    >Delete</span
                  >
                </b-popover>
              </div>
            </div>
            <li class="pl-3">{{ skill.questions[0].question }}</li>
            <div class="d-grid row-cols-2 my-3">
              <label
                v-for="(optionAnswer, index) in optionalAnswers"
                :key="`asnwer-${index}-skill-${skill.id}`"
                class="mx-3"
              >
                <input
                  type="radio"
                  :value="optionAnswer.id"
                  :name="`skill-${skill.questions[0].id}-${skill.id}`"
                  v-model.lazy="answer[skill.questions[0].id]"
                  @change="touched = true"
                />
                <span class="ml-2">{{ optionAnswer.text }}</span>
              </label>
            </div>
          </div>
        </div>
      </section>
    </div>

    <footer class="d-flex flex-wrap flex-gap justify-content-center parent-goals-controls">
      <b-button type="submit" pill variant="warning" class="px-5" :disabled="!touched">
        Save
      </b-button>
      <custom-button class="px-4" router :to="{ name: 'Progress' }">
        Next: Check Progress
      </custom-button>
    </footer>
  </form>
</template>
<script>
import { mapGetters } from 'vuex';
import CustomButton from '@/components/general/CustomButton.vue';

export default {
  components: {
    CustomButton,
  },
  props: {
    skills: {
      type: Array,
      default: () => [],
    },
    optionalAnswers: {
      type: Array,
      default: () => [],
    },
    favorites: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      answer: {},
      touched: false,
      onDesk: false,
    };
  },
  mounted() {
    if (!this.skills.length) return;

    this.skills.forEach((skill) => {
      const question = String(skill.questions[0].id);
      const data = skill.questions[0].answer;
      if (data) this.answer = { ...this.answer, [question]: data };
    });
    this.resizeWindow();
    window.onresize = () => {
      this.resizeWindow();
    };
  },
  computed: {
    ...mapGetters('parent', ['getFavoriteSkills']),
  },
  methods: {
    handleDelete(skillId, answer) {
      delete this.answer[answer];
      this.$emit('onDeleteGoal', { skillId });
    },
    isAFavoriteSkill(skillId) {
      return this.getFavoriteSkills.includes(skillId);
    },
    handleFavoriteSkill(skillId) {
      this.$emit('onClickFavorite', skillId);
    },
    answersToEmitAdapter(answers = {}) {
      if (!Object.keys(answers).length) return [];
      const questionIds = Object.keys(answers);
      const answersAdapter = questionIds.map((questionId) => ({
        question: questionId,
        answer: answers[questionId],
      }));
      return answersAdapter;
    },
    handleForm() {
      this.touched = false;
      const answersToSave = this.answersToEmitAdapter(this.answer);
      this.$emit('onSave', { answers: answersToSave });
    },
    resizeWindow() {
      try {
        const centerWidth = document.documentElement.clientWidth;
        if (centerWidth > 1023) {
          this.onDesk = true;
        } else {
          this.onDesk = false;
        }
      } catch (error) {
        console.log('Error onresize: ', error);
      }
    },
  },
};
</script>
<style lang="scss">
.border-table {
  border: solid 3px var(--color-main);
}

.disabled {
  color: lightgray;
  pointer-events: none;
}

.parent-goals-controls {
  @media screen and (max-width: 480px) {
    button,
    a {
      width: 100%;
    }
  }
}
</style>
